import { createApi } from '@reduxjs/toolkit/query/react';
import { RobotFilterList, RobotFiltersUpdateShape } from 'models/robots';
import { baseQuery } from 'store/_Api';

export const RobotsFilterListApi = createApi({
  reducerPath: 'RobotsFilterListApi',
  tagTypes: ['Filters'],
  baseQuery,
  endpoints: (builder) => ({
    getFilters: builder.query<RobotFilterList, string>({
      // need to specify the typeing instead of any
      query: (url) => ({
        url: url,
      }),
      providesTags: ['Filters'],
    }),
    updateFilters: builder.mutation<
      string,
      {
        url: string;
        filters: RobotFiltersUpdateShape;
      }
    >({
      query: (data) => ({
        url: data.url,
        method: 'PATCH',
        body: data.filters,
      }),
      invalidatesTags: ['Filters'],
    }),
  }),
});

export const { useGetFiltersQuery, useUpdateFiltersMutation } =
  RobotsFilterListApi;
